import styled from "styled-components";

export const CellsContainer = styled.div`
  width: 100%;
  padding-left: 16px;
  border-left: solid 1px darkslategrey;
`;
